var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.opened
    ? _c("div", [
        _c("div", { staticClass: "action-sheet main-dim" }, [
          _c(
            "div",
            { staticClass: "action-sheet-content", class: [_vm.active] },
            [
              _vm.actionHeader
                ? _c(
                    "div",
                    {
                      staticClass: "action-sheet-header",
                      class: { hasborder: _vm.useTopBorder }
                    },
                    [
                      _c("div", { staticClass: "action-sheet-title" }, [
                        _c("h4", [_vm._v(_vm._s(_vm.title))]),
                        _c("button", {
                          staticClass: "btn-close",
                          on: {
                            click: function($event) {
                              return _vm.close()
                            }
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "description" },
                        [
                          _vm._t("subtitle", [
                            _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                            _vm.subtitle2 ? _c("br") : _vm._e()
                          ]),
                          _vm._t("subtitle2", [
                            _vm._v(" " + _vm._s(_vm.subtitle2) + " "),
                            _vm.subtitle3 ? _c("br") : _vm._e()
                          ]),
                          _vm._t("subtitle3", [_vm._v(_vm._s(_vm.subtitle3))])
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm.actionBody
                ? _c(
                    "div",
                    {
                      staticClass: "action-sheet-body",
                      class: [
                        { paddingbtm: !_vm.actionFooter },
                        { "padding-x": _vm.paddingX }
                      ]
                    },
                    [_vm._t("content")],
                    2
                  )
                : _vm._e(),
              _vm.actionFooter
                ? _c(
                    "footer",
                    {
                      staticClass: "action-sheet-footer",
                      class: [{ hasborder: _vm.useBottomBorder }]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-area--bottom" },
                        [
                          _vm._t("footer", [
                            _c("button", [_vm._v(_vm._s(_vm.cancel))]),
                            _c("button", [_vm._v(_vm._s(_vm.confirm))])
                          ])
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm.noDimClose
          ? _c("div", { staticClass: "action-sheet-dim main-dim" })
          : _c("div", {
              staticClass: "action-sheet-dim main-dim",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }